import request from '@/utils/request'

function getLessonInfo (lessonId) {
  return request({
    url: '/pos/activity/show',
    method: 'post',
    data: { id: lessonId }
  })
}

function checkIn (params) {
  return request({
    url: '/pos/ticket/checkIn',
    method: 'post',
    data: params
  })
}

function getScannableActivities () {
  return request({
    url: '/pos/activity/index',
    method: 'get'
  })
}

export default {
  getLessonInfo,
  checkIn,
  getScannableActivities
}
